exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-logged-out {\n  padding: 1rem 0 0; }\n\n.branding {\n  text-decoration: none; }\n\n.branding-img {\n  margin: -10px 0 0; }\n\n.branding-name {\n  color: black;\n  font-family: 'Arial', 'Helvetica', sans-serif;\n  font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/login-module/header-logged-out/header-logged-out.component.scss
// module id = ../../../../../src/app/login-module/header-logged-out/header-logged-out.component.scss
// module chunks = main